<!-- Global SVG defs: glow filter used by sigils and the ouroboros. -->
<svg width="0" height="0" style="position:absolute" aria-hidden="true">
  <defs>
    <filter id="glow" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation="2.4" result="b" />
      <feMerge>
        <feMergeNode in="b" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>
</svg>
